/* eslint-disable quote-props */
export function convertFromDatepickerToDateFnsPattern(datePickerPattern) {
  const patternMap = {
    'YY': 'yy',
    'YYYY': 'yyyy',
    'Y': 'y',
    'M': 'M',
    'MM': 'MM',
    'MMM': 'MMM',
    'MMMM': 'MMMM',
    'D': 'd',
    'DD': 'dd',
    'd': 'i',
    'dd': 'eee',
    'ddd': 'eee',
    'dddd': 'eeee',
    'A': 'a',
    'a': 'aaa',
    'H': 'H',
    'HH': 'HH',
    'h': 'h',
    'hh': 'hh',
    'm': 'm',
    'mm': 'mm',
    's': 's',
    'ss': 'ss',
    'S': 'S',
    'SS': 'SS',
    'SSS': 'SSS',
    'Z': 'XXX',
    'ZZ': 'XX',
    'w': 'w',
    'ww': 'ww',
    'X': 'X',
    'x': 'x',
  };

  return datePickerPattern.split('').map((char) => patternMap[char] || char).join('');
}

export function convertFromDatepickerToPrimeVuePattern(datePickerPattern) {
  const patternMap = {
    'YY': 'y',
    'YYYY': 'yy',
    'Y': 'yy',
    'M': 'm',
    'MM': 'mm',
    'MMM': 'M',
    'MMMM': 'MM',
    'D': 'd',
    'DD': 'dd',
    'd': 'D',
    'ddd': 'D',
    'dddd': 'DD',
    'A': '',
    'a': '',
    'H': '',
    'HH': '',
    'h': '',
    'hh': '',
    'm': '',
    'mm': '',
    's': '',
    'ss': '',
    'S': '',
    'SS': '',
    'SSS': '',
    'Z': '',
    'ZZ': '',
    'w': 'w',
    'ww': 'ww',
    'X': '@',
    'x': '@',
    ':': '',
  };

  const result = datePickerPattern.split(/(YY(?:YY)?|M{1,4}|D{1,4}|[Hh]{1,2}|m{1,2}|s{1,2}|S{1,3}|[AZXx]|.)/g)
    .map((char) => {
      return patternMap[char] != null ? patternMap[char] : char;
    })
    .join('')
    .trim();
  return result;
}

export function convertPrimeVueToDateFnsPattern(primeVuePattern) {
  const patternMap = {
    'd': 'd',
    'dd': 'dd',
    'o': 'D',
    'oo': 'DDD',
    'D': 'eee',
    'DD': 'eeee',
    'm': 'M',
    'mm': 'MM',
    'M': 'MMM',
    'MM': 'MMMM',
    'y': 'yy',
    'yy': 'yyyy',
    'a': 'aaa',
    'A': 'a..aa',
    '@': 't', // UNIX timestamp in `date-fns`
    '!': '', // No direct equivalent for Windows ticks
    "'": "''", // eslint-disable-line quotes
  };

  return primeVuePattern.split(/(d{1,2}|o{1,2}|D{1,2}|m{1,2}|M{1,2}|y{1,2}|@|!|')/g)
    .map((token) => patternMap[token] || token)
    .join('');
}
